import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TuiDialogContext } from '@taiga-ui/core';
import { injectContext } from '@taiga-ui/polymorpheus';
import { Optional } from '@src/types/utils';

@Component({
  selector: 'app-successful-save-dialog',
  templateUrl: './successful-save-dialog.component.html',
  styleUrls: ['./successful-save-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuccessfulSaveDialogComponent {
  private readonly context = injectContext<TuiDialogContext<void, Optional<string>>>();

  onClickExitButton() {
    this.context.completeWith();
  }

  get requestTitle() {
    return this.context.data ?? '';
  }
}
